<script lang="ts">
	import Disclosure from "@components/common/Disclosure.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import type { Snippet } from "svelte";

	const {
		title,
		faqs,
		group,
		media,
	}: {
		title: string;
		faqs: { question: string; answer: string }[];
		group: string;
		media?: Snippet;
	} = $props();
</script>

<section
	class="full-width grid-container py-10 sm:py-15 md:py-20 lg:pt-25 lg:pb-5 xl:pt-30 xl:pb-10 2xl:pt-40 2xl:pb-20 gap-y-10 sm:gap-y-15 md:gap-y-20 lg:gap-y-25 xl:gap-y-30 2xl:gap-y-40"
>
	<div
		class={[
			"container-8",
			media ? "xl:container-start-7 xl:container-end-12" : "xl:container-start-3 xl:container-end-10",
		]}
	>
		<Heading level={2} text={title} class="heading-2 text-fcrdarkgray text-center xl:text-left mb-18" />
		<div class="md:min-h-100">
			{#each faqs as faq, index (index)}
				<Disclosure title={faq.question} {group}>
					<Formatted text={faq.answer} />
				</Disclosure>
			{/each}
		</div>
	</div>
	{#if media}
		<div class="xl:order-first xl:container-start-1 xl:container-end-6 flex items-start justify-center xl:h-full">
			{@render media()}
		</div>
	{/if}
</section>
